<template>
  <div class="hello">
    <h1>{{ $t("text.common.404_page_notfound") }}</h1>
  </div>
</template>

<script>
export default {}
</script>
